import styled from "styled-components";

import { blue } from "@mui/material/colors";
import { faMapPin } from "@fortawesome/free-solid-svg-icons";
import {
  MarkerF,
  PolylineF,
  OverlayViewF,
  OverlayViewProps,
} from "@react-google-maps/api";

export const defaultOptions = {
  zIndex: 0,
  visible: true,
  radius: 10000,
  fillOpacity: 1,
  strokeWeight: 6,
  editable: false,
  strokeOpacity: 1,
  fillColor: "red",
  clickable: false,
  draggable: false,
  strokeColor: blue[600],
};

interface Props {
  path: { lat: number; lng: number }[];
  options?: google.maps.PolylineOptions;
  pinOnStart?: boolean;
}

const Point = styled.div`
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 20px;
  border: 2px solid black;
`;

const StartEndPoint = ({ ...props }: OverlayViewProps & {}) => {
  return (
    <OverlayViewF
      getPixelPositionOffset={(width, height) => ({
        x: -(width / 2),
        y: -(height / 2),
      })}
      {...props}
    >
      <Point />
    </OverlayViewF>
  );
};

export const RoutePolyline = ({ path, options, pinOnStart = true }: Props) => {
  const startPoint = path.length > 2 ? path[0] : undefined;
  const endPoint = path.length > 2 ? path[path.length - 1] : undefined;

  const startIcon = {
    fillOpacity: 1,
    fillColor: "blue",
    path: faMapPin.icon[4] as string,
    anchor: new google.maps.Point(
      faMapPin.icon[0] / 2, // width
      faMapPin.icon[1] // height
    ),
    strokeWeight: 1,
    strokeColor: "#ffffff",
    scale: 0.05,
  };

  return (
    <>
      <PolylineF options={{ ...defaultOptions, ...options }} path={path} />
      {startPoint && (
        <StartEndPoint position={startPoint} mapPaneName="overlayMouseTarget" />
      )}
      {startPoint && pinOnStart && (
        <MarkerF position={startPoint} options={{ icon: startIcon }} />
      )}
      {endPoint && (
        <StartEndPoint position={endPoint} mapPaneName="overlayMouseTarget" />
      )}
    </>
  );
};
